import { render, staticRenderFns } from "./article.vue?vue&type=template&id=0ff672b4&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&id=0ff672b4&prod&lang=css&"
import style1 from "./article.vue?vue&type=style&index=1&id=0ff672b4&prod&lang=less&scoped=true&"
import style2 from "./article.vue?vue&type=style&index=2&id=0ff672b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff672b4",
  null
  
)

export default component.exports